module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('request-status', {
    attrs: {
      "request": _vm.requests.get,
      "message200": false
    }
  }), _vm._v(" "), _c('v-card-title', {
    staticClass: "subtitle-1 overline py-0 grey lighten-4"
  }, [_vm._v("\n    " + _vm._s(_vm.title) + "\n    "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-alert', {
    staticClass: "ma-0 lighten-2",
    attrs: {
      "type": "info",
      "value": true,
      "dismissible": "",
      "dense": ""
    }
  }, [_vm._v("\n    Below is a list of submissions which could not be automatically assigned to a client.\n    Choose \"assign\" next to the submission/s you would like to set for this client\n  ")]), _vm._v(" "), _c('request-status', {
    attrs: {
      "request": _vm.requests.assign,
      "message200": false
    },
    on: {
      "ok": _vm.assignSuccess
    }
  }), _vm._v(" "), _c('v-list', {
    staticClass: "pa-0"
  }, [_c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("Unlinked submissions\n      "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.requests.get.loading,
      "small": "",
      "icon": ""
    },
    on: {
      "click": _vm.get
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("replay")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (!_vm.requests.get.loading && _vm.submissions && _vm.submissions.length === 0) ? _c('div', {
    staticClass: "pa-3"
  }, [_vm._v("\n      Couldn't find any unlinked sumissions\n    ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.submissions), function(sub) {
    return _c('submission-list-item', {
      key: sub.id,
      attrs: {
        "item": sub,
        "with-actions": false
      }
    }, [_c('v-list-tile-action', {
      attrs: {
        "slot": "list-tile-action"
      },
      slot: "list-tile-action"
    }, [_c('v-btn', {
      attrs: {
        "small": "",
        "outline": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.assign(sub)
        }
      }
    }, [_vm._v("\n          Assign\n        ")])], 1)], 1)
  })], 2), _vm._v(" "), _vm._t("card-actions")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c410d5a6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Integrations/JotForm/AssignSubmission.vue
// module id = 1519
// module chunks = 9